import { useSelector } from "react-redux"
import Loading from 'assets/lotties/loading.json'
import Lottie from "react-lottie"
const BackdropComponent = () => {
  const { open } = useSelector((state: any) => state.loading)

  return (
    <div className={open ? "z-[100] fixed w-screen h-screen bg-black/50 backdrop-filter: blur(20px) flex justify-center items-center animate-fade-in-down" : "hidden"}>
      <Lottie options={{ loop: true, autoplay: true, animationData: Loading }} height="150px" />
    </div>
  )
}

export default BackdropComponent